module.exports = __webpack_public_path__ + "static/cb-bg.ca0777a4.png";